const featureItems = [
  {
    icon: 'ri-4k-fill',
    title: '高清画质',
    desc: '支持标清、高清、超清多档画质自由切换，H.265高效编码在保证画质的同时大幅降低带宽消耗。无论大屏电视还是手机小屏，都能呈现细腻震撼的视觉体验。',
  },
  {
    icon: 'ri-speed-up-fill',
    title: '极速加载',
    desc: '智能多线CDN加速网络覆盖全国，系统自动匹配最优服务节点。独家预加载技术让影片秒开播放，拖动进度条零等待，真正实现即点即播的流畅体验。',
  },
  {
    icon: 'ri-shield-star-fill',
    title: '安全无忧',
    desc: '全站HTTPS加密传输保护您的隐私安全，纯净观影环境无弹窗广告骚扰。智能内容过滤系统持续优化，确保每一位用户都能安心畅享纯净的观影时光。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1024px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-primary-500/10 text-primary-400 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-medal-line text-xs"></i>
            核心优势
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-100 mb-2">
            平台优势
          </h2>
          <p className="text-foreground-500 text-sm">为什么5000万用户选择四虎影视大全</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featureItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-200/70 rounded-2xl border border-background-300/40 p-6 md:p-8 text-center hover:border-background-400/60 transition-all cursor-pointer"
            >
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-500/10 mb-5 group-hover:bg-primary-500/15 transition-colors">
                <i className={`${item.icon} text-primary-400 text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-200 mb-3">
                {item.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}